import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    QueryList,
    ViewChildren,
    input,
    output,
    signal,
} from '@angular/core';

import { MobiUiPaginatorComponent, MobiUiPaginatorPageEvent } from '@mobi/rwc-ui-components-ng-jslib';
import { TranslatePipe } from '@mobi/rwc-utils-ng-jslib';

import { SEARCH_PAGE_SIZE } from '../../../../util/constant/common';
import { SearchResultItem, SearchResultItemComponent } from '../search-result-item/search-result-item.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'oiv-viewer-search-result-list',
    imports: [SearchResultItemComponent, MobiUiPaginatorComponent, TranslatePipe],
    templateUrl: './search-result-list.component.html',
    styleUrls: [
        './search-result-list.component.scss',
        '../../../../../../../../apps/oiv-viewer-b2e-rwc/src/styles.scss',
    ],
})
export class SearchResultListComponent implements AfterViewInit {
    @ViewChildren(SearchResultItemComponent) searchResultItems!: QueryList<SearchResultItemComponent>;
    ngAfterViewInit(): void {
        if (this.selectFirstResult()) {
            const firstItem = this.searchResultItems.first;
            if (firstItem) {
                firstItem.navigateToResult();
            }
        }
    }
    changePage = output<MobiUiPaginatorPageEvent>();

    keySearch = input<string>('');
    allResultItemsPerPage = input<SearchResultItem[]>([]);
    numberHits = input<number>(0);
    currentPage = input<number>(0);
    selectFirstResult = input<boolean>(false);
    pageSize = signal(SEARCH_PAGE_SIZE);

    onChangePage(pageEvent: MobiUiPaginatorPageEvent): void {
        this.changePage.emit(pageEvent);
    }
}
